// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3QyUr","productName":"Table_productName__3irYL"};